import { Modal, Button } from "react-bootstrap";
import * as APIModels from "../../../../models";
import { DivisionRuleListDetailedResponse } from "../../../../models/swagger/generated-client-service";
import { useEffect, useState } from "react";

export type DeleteConfirmModalProps = {
    show: boolean;
    files: APIModels.FileInfo[];
    onOk: () => void;
    onClose: () => void;
};

export default function DeleteConfirmModal({
    show,
    files,
    onOk,
    onClose,
}: DeleteConfirmModalProps) {
    /*
    <div className="spinner-border text-primary m-2" role="status">
        <span className="visually-hidden">Loading...</span>
    </div>;
    */
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading && show == false) {
            setLoading(false);
        }
    }, [show]);

    return (
        <Modal show={show} aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Delete Confirmation
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Warning:</h4>
                <p
                    style={{
                        fontSize: "14px",
                    }}
                >
                    Are you sure you want to delete?
                    <p
                        style={{
                            fontSize: "14px",
                        }}
                    >
                        Deleting this file will remove it from your uploads.
                    </p>
                </p>
                <tbody>
                    {!loading ? (
                        <tr>
                            File:{" "}
                            {files.map((file, i) => {
                                return <p>{file.filename}</p>;
                            })}
                        </tr>
                    ) : (
                        <div
                            className="spinner-border text-primary m-2"
                            role="status"
                        >
                            <span className="visually-hidden"></span>
                        </div>
                    )}
                </tbody>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-primary waves-effect waves-light"
                    type="button"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-danger waves-effect waves-light"
                    type="button"
                    onClick={() => {
                        setLoading(true);
                        onOk();
                    }}
                >
                    Delete
                </button>
            </Modal.Footer>
        </Modal>
    );
}
